import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CemenSearch.scss';
import fetch from '../../../../../core/fetch';
import SelectFile from "../../../../SelectFile";

class CemenSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      views: [],
      godzina: 0,
      doba: 0,
      miesiac: 0,
      uzytkownikGrobu: null,
      grobyTabela: null,
      showMore: false,
      choosenGraveyard: null,
      optionsGraveyard: null,
      wybranyGrob: null,
      lightboxIsOpen: false,
      lightboxCurrentImg: 0,
      images: [],
      img: null,
      editImage: null,
      fileName: '',
      fileList: null,
      isFileSelected: false,
      shouldReset: false,
    };
  }

  componentDidMount(): void {
    return fetch(`${process.env.API_URL}/cmentarze/${prefix}/cmentarze`)
      .then((resp) => resp.json())
      .then(resp => {
        this.setState({
          optionsGraveyard: resp,
        })
      })
      .catch(err => console.error(err));
  }

  componentWillReceiveProps(nextProps) {
    if(JSON.stringify(this.state.graveyard) !== JSON.stringify(nextProps.graveyard)) {
      this.setState({
        optionsGraveyard: nextProps.graveyard
      })
    }
    if (JSON.stringify(this.state.wybranyGrob) !== JSON.stringify(nextProps.wybranyGrob)){
      this.setState({
        wybranyGrob: nextProps.wybranyGrob
      });
    }
  }

  changeSearchEngine = (str) => {
    const imienazw = str.target.value;
    if (imienazw.length >= 2) {
      fetch(`${process.env.API_URL}/cmentarze/${this.props.prefix}/znajdz/groby?imienazw=${imienazw}&id_cmentarz=${this.state.choosenGraveyard}`)
      .then(resp => {
        return resp.json();
      })
      .then(resp => {
        this.setState({
          grobyTabela: resp,
        });
      })
      .catch(err => console.error(err));
    } else if (imienazw.length <= 1) {
      this.setState({
        grobyTabela: null,
        uzytkownikGrobu: null,
      });
    }
  };

  onFileSelect = (inputState) => this.setState({ ...inputState, shouldReset: false });
  postImage = (image_data, file) => {
    const formData = new FormData();
    formData.append('file', file);

    fetch(`${process.env.API_URL}/zdjecie_grobu/${this.props.prefix}/${image_data.id_grobu}/${image_data.zdjecie}.jpg`, {
      method: 'POST',
      body: formData,
    })
    .then((response) => {
      if (response.status === 200) {
        this.setState({
          shouldReset: true,
          fileList: null,
          fileName: null,
        });
        return response.json();
      }
    })
    .catch((error) => { console.error(error) });
    alert(error);
  };

  handleChoseGraveyard = (id) => {
    this.setState({
      choosenGraveyard: id
    });
  };

  chooseGrave = (item) => {
    const id_grobu = item.target.value;

    if (id_grobu.length > 0) {
      fetch(`${process.env.API_URL}/cmentarze/${this.props.prefix}/grob?idzmarlego=${id_grobu}`)
      .then(resp => {
        return resp.json();
      })
      .then(resp => {
        this.setState({
          uzytkownikGrobu: resp,
        });
      })
      .catch(err => console.error(err));
    } else if (id_grobu.length <= 1) {
      this.setState({
        uzytkownikGrobu: null,
      });
    }
  };

  picturesList() {
    return this.state.uzytkownikGrobu.images.map((picture) => {
      return (
        <tr className="" key={picture.zdjecie}>
          <td>
            <img
              className="grave__picture"
              src={
                `${process.env.API_URL}/zdjecie_grobu/${this.props.prefix}/${picture.id_grobu}/${picture.zdjecie}.jpg`
              }
              alt={picture.opis}>
            </img>
          </td>
          <td>
            {picture.zdjecie}.jpg
          </td>
          <td>
            {picture.publikacja ?
              <span className="glyphicon glyphicon glyphicon-ok" aria-hidden="true">&nbsp;</span> :
              <span className="glyphicon glyphicon glyphicon-remove" aria-hidden="true">&nbsp;</span>}
          </td>
          <td>
            <button className="btn btn-secondary">Publikacja</button>
          </td>
          <td>
            <div>
              <SelectFile
                shouldReset={this.state.shouldReset}
                accept=".jpg"
                btnText=".JPG"
                multiple={false}
                labelType="default"
                buttonType="info"
                onFileSelect={(inputState) => this.onFileSelect(inputState)}
              />
              <button
                onClick={() => this.postImage(picture, this.state.fileList)}
                type="button"
                className="btn btn-primary">
                Wyślij
              </button>
            </div>
          </td>
          <td>
            <a href={`${process.env.API_URL}/zdjecie_grobu/${this.props.prefix}/${picture.id_grobu}/${picture.zdjecie}.jpg`}
               className="btn btn-secondary"
               target="_blank">
              Otwórz
            </a>
          </td>
        </tr>
      );
    });
  }

  render() {
    return (
      <div className="col-xs-12">
        <div className="row">
          {this.state.optionsGraveyard ? this.state.optionsGraveyard.features.map(v => {
            return (
              <button
                className={
                  this.state.choosenGraveyard === v.properties.id ? "btn btn-lg btn-primary" : " btn btn-lg btn-secondary"
                }
                onClick={() => this.handleChoseGraveyard(v.properties.id)}>{v.properties.nazwa}
              </button>
            )
          }) : null}
        </div>
        <div className="form-group">
          <input
            type="text"
            placeholder="np.: Imię Nazwisko 01.01.1900"
            className="form-control cmentarze_area"
            style={{padding: '20px', fontSize: '24px', lineHeight: '24px'}}
            onChange={(e) => this.changeSearchEngine(e)}/>
          <label htmlFor="select" style={{ fontSize: '14px' }}>
            Wyszukaj po imieniu, nazwisku lub dacie zgonu
          </label>
          <span className="fa fa-search fa-3x searchInputIcon" style={{ color: '#336633' }}>
            &nbsp;
          </span>
        </div>

        <div className="form-group graves-info-list" style={{ width: '100%', marginTop: '20px' }}>
          <label htmlFor="listaZmarlych" style={{ fontSize: '14px' }}>
            Wybierz zmarłego z listy:
          </label>
          <select
            onChange={(e) => this.chooseGrave(e)}
            size={this.state.grobyTabela !== null && this.state.grobyTabela.length < 5 ? this.state.grobyTabela.length + 1 : '5' }
            className="form-control groby-select cmentarze_area"
            name="listaZmarlych">
            {this.state.grobyTabela !== null && this.state.grobyTabela.length === 0 ? <option>brak wyników</option> : ''}
            {(this.state.grobyTabela !== null) ? this.state.grobyTabela.map((v, i) => {
              return (
                <option key={v + i} value={v.id} style={{ padding: '5px 0', fontSize: '25px' }}>
                  &#10014; {v.nazwisko} {v.imie} zm. {v.data_zgonu}
                </option>
                );
            }) : ''}
          </select>
        </div>

        {
          this.state.uzytkownikGrobu ?
          <div className="graves-info-list" style={{ width: '100%', marginTop: '20px' }}>
            <table>
              <tbody>
                <tr className="background_table_zmarly">
                  <td>Imię:</td>
                  <td>{ this.state.uzytkownikGrobu.imie }</td>
                </tr>
                <tr>
                  <td>Nazwisko:</td>
                  <td>{ this.state.uzytkownikGrobu.nazwisko }</td>
                </tr>
                <tr className="background_table_zmarly">
                  <td>Data śmierci:</td>
                  <td>{ this.state.uzytkownikGrobu.data_zgonu }</td>
                </tr>
                <tr>
                  <td>Data urodzenia:</td>
                  <td>{ this.state.uzytkownikGrobu.data_urodzenia }</td>
                </tr>
                <tr className="background_table_zmarly">
                  <td>Wiek:</td>
                  <td>{ this.state.uzytkownikGrobu.wiek }</td>
                </tr>
                <tr>
                  <td>Nr sektora:</td>
                  <td>{ this.state.uzytkownikGrobu.nr_ewid_sektor }</td>
                </tr>
                <tr className="background_table_zmarly">
                  <td>Nr rzędu:</td>
                  <td>{ this.state.uzytkownikGrobu.nr_ewid_rzad }</td>
                </tr>
                <tr>
                  <td>Nr grobu:</td>
                  <td>{ this.state.uzytkownikGrobu.nr_ewid_grob }</td>
                </tr>
              </tbody>
            </table>
            <h4>Zdjęcia</h4>
              <table className="table">
                <thead>
                  <tr>
                    <th>Zdjęcie</th>
                    <th>Nazwa/Numer</th>
                    <th>Publikacja</th>
                  </tr>
                </thead>
                <tbody>
                {
                  this.state.uzytkownikGrobu.images.length > 0 ?
                  this.picturesList() :
                  <p>Brak zdjęć do wyświetlenia</p>
                }
                </tbody>
              </table>
          </div> :
          <p>Wybierz z listy aby wyświetlić dane</p>
        }
      </div>
    );
  }
}

export default withStyles(s)(CemenSearch);



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/CemenSearch/CemenSearch.js